import http from "../../helpers/http";

import {
  FETCH_PROJECT_UNITE_CONTENT_SUCCESS,
  FETCH_PROJECT_UNITE_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("project-unite")
    .then(({ data }) => {
      dispatch({
        type: FETCH_PROJECT_UNITE_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_PROJECT_UNITE_CONTENT_FAILED,
        payload: error
      });
    });
};
